import React from 'react';
import styled from 'styled-components';
import { 
  BarChart as RechartsBar, 
  Bar, 
  XAxis, 
  YAxis, 
  CartesianGrid, 
  Tooltip, 
  ResponsiveContainer 
} from 'recharts';

const ChartWrapper = styled.div`
  width: 100%;
  height: ${props => props.$height || '200px'};
`;

const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #6b7280;
  font-size: 13px;
`;

const BarChart = ({ 
  data = [],
  height = '200px',
  color = '#8b5cf6',
  dataKey = 'value',
  xKey = 'name',
  showGrid = true,
  rounded = true,
  formatValue,
  formatYAxis,
  emptyMessage = 'No data'
}) => {
  if (!data || data.length === 0) {
    return (
      <ChartWrapper $height={height}>
        <EmptyState>{emptyMessage}</EmptyState>
      </ChartWrapper>
    );
  }

  return (
    <ChartWrapper $height={height}>
      <ResponsiveContainer width="100%" height="100%">
        <RechartsBar data={data} margin={{ top: 8, right: 12, left: 0, bottom: 0 }}>
          {showGrid && <CartesianGrid strokeDasharray="3 3" stroke="#eef2f7" />}
          <XAxis
            dataKey={xKey}
            tick={{ fontSize: 11, fill: '#64748b' }}
            minTickGap={20}
          />
          <YAxis
            tick={{ fontSize: 11, fill: '#64748b' }}
            width={40}
            tickFormatter={formatYAxis}
          />
          <Tooltip
            formatter={formatValue ? (v, name) => [formatValue(v), name] : undefined}
            contentStyle={{ fontSize: 12, borderRadius: 8 }}
          />
          <Bar
            dataKey={dataKey}
            fill={color}
            radius={rounded ? [4, 4, 0, 0] : 0}
            isAnimationActive={false}
          />
        </RechartsBar>
      </ResponsiveContainer>
    </ChartWrapper>
  );
};

export default BarChart;
